const getPageInfo = () => {
  const { adobeDataLayer: { getState } = {} } = window
  return (getState && getState("page")) || {}
}

const getPageType = () => {
  const page = getPageInfo()
  const {
    category: { pageType = "" },
  } = page
  return pageType
}

const addAnalyticsForNewsletterSignupOverlay = () => {
  const pageType = getPageType()

  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "newsletter signup overlay",
    eventMsg: "n/a",
    eventName: "newsletter signup overlay",
    eventStatus: "n/a",
    eventType: "popup",
    internalLinkName: "newsletter signup",
    internalLinkPosition: "newsletter signup",
    internalLinkType: "newsletter signup overlay",
    internalLinkURL: "n/a",
    internalLinkZoneName: `${pageType}:newsletter signup overlay`,
  }
  addAnalyticsForNewsletterSignup(eventInfo, "cmp:show")
}

const addAnalyticsForNewsletterSignupBtn = (eventStatus, eventMsg = "n/a") => {
  const pageType = getPageType()

  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "newsletter signup",
    eventMsg,
    eventName: "newsletter signup",
    eventStatus,
    eventType: "click",
    internalLinkName: "sign up",
    internalLinkPosition: "newsletter signup",
    internalLinkType: "newsletter signup overlay:submit",
    internalLinkURL: "n/a",
    internalLinkZoneName: `${pageType}:newsletter signup overlay`,
  }

  addAnalyticsForNewsletterSignup(eventInfo, "cmp:click")
}

const addAnalyticsForNewsletterSignup = (eventInfo, event) => {
  const page = getPageInfo()

  window.adobeDataLayer.push({
    event,
    eventInfo,
    page,
  })
}

export {
  addAnalyticsForNewsletterSignupOverlay,
  addAnalyticsForNewsletterSignupBtn,
}
